export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_q03_b.503dc356.png";